module.exports = __webpack_public_path__ + "static/media/title-detail.3e1c6538.svg";